var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pull-right"},[_c('a',{staticClass:"btn btn-sm",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.$router.go(-1)}}},[_c('i',{staticClass:"fa fa-caret-left"}),_vm._v(" Go Back\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-482cc9e2","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Goback.vue
// module id = 1507
// module chunks = 27